    <div class="sectionContainer">
        <h3>Locations</h3>
        <table class="projectSectionTable">
            <thead>
                <tr>
                    <th class="itemHead firstColumn"></th>
                    <th class="itemHead">Country</th>
                    <th class="itemHead">Locality</th>
                    <th class="itemHead">Location</th>
                </tr>
            </thead>
            <tbody>
                <!--  ng-class="highlightClass(projectLocation.created, projectLocation.updated);" -->
                <tr *ngFor="let projectLocation of projectLocations" class="item" [ngClass]="highlightClass(projectLocation.created, projectLocation.updated)">
                    <td class="item"> {{projectLocation.main}}
                    </td>
                    <td class="item" [innerHTML]="projectLocation.country |  highlight: searchTerm">
                    </td>
                    <td class="item" [innerHTML]="projectLocation.locality |  highlight: searchTerm">
                    </td>
                    <td class="item" [innerHTML]="projectLocation.location |  highlight: searchTerm">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

